<div class="general">
    <h2 mat-dialog-title>{{title}}</h2>
    <mat-divider></mat-divider>
    <mat-dialog-content>
        <div class="field-row">
            <h5>NOMBRE</h5>
            <mat-form-field appearance="outline">
                <input matInput [(ngModel)]="groupName" placeholder="Nombre del grupo de reglas">
            </mat-form-field>
        </div>
        <div class="field-row">
            <h5>CONDICIONANTE</h5>
            <mat-form-field appearance="outline">
                <mat-select [(ngModel)]="operator">
                    @for (op of operatorChoices; track op.value) {
                    <mat-option [value]="op.value">{{ op.label }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="field-row">
            <h5>DÍAS DE VACACIONES</h5>
            <mat-form-field appearance="outline" class="small-field">
                <input matInput type="number" [(ngModel)]="daysEntitled" placeholder="0" min="0">
            </mat-form-field>
            <span class="field-hint">Número de días de vacaciones que corresponden a esta opción</span>
        </div>
        <div class="field-row">
            <h5>SEMANAS EXENTAS</h5>
            <mat-form-field appearance="outline" class="small-field">
                <input matInput type="number" [(ngModel)]="exemptWeeks" placeholder="0" min="0">
            </mat-form-field>
            <span class="field-hint">Número de semanas libres que no cuentan para las reglas</span>
        </div>
        <div class="field-row checkbox-row">
            <mat-checkbox [(ngModel)]="isDeterminant">Es determinante</mat-checkbox>
            <span class="field-hint">Indica si este grupo define el patrón de vacaciones elegido</span>
        </div>
    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button mat-button class="cancel" (click)="onCancel()">{{cancelText}}</button>
        @if (isEditMode) {
        <button mat-button class="delete-action" (click)="onDelete()">{{deleteText}}</button>
        }
        <button mat-button class="confirm" (click)="onConfirm()" [disabled]="!groupName.trim()">{{confirmText}}</button>
    </mat-dialog-actions>
</div>